"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Award, Heart, Flame, Users, Star } from "lucide-react";
export default function ChefYConcepto() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const values = [{
    icon: Award,
    title: "Excelencia Culinaria",
    description: "Cada plato es una obra maestra de sabor y presentación meticulosa."
  }, {
    icon: Heart,
    title: "Pasión Auténtica",
    description: "Dedicación absoluta a crear una experiencia gastronómica inmersiva."
  }, {
    icon: Flame,
    title: "Innovación Constante",
    description: "Técnicas tradicionales mexicanas elevadas con un toque contemporáneo."
  }, {
    icon: Users,
    title: "Experiencia Compartida",
    description: "Momentos memorables diseñados para ser disfrutados en compañía."
  }, {
    icon: Star,
    title: "Compromiso Total",
    description: "Ingredientes selectos de la región y procesos artesanales."
  }];
  return <section id="chef-y-concepto" ref={sectionRef} className="relative min-h-screen bg-secondary-dark overflow-hidden dark-section">
      <div className="grid lg:grid-cols-12 min-h-screen">
        {}
        <div className="relative lg:col-span-5 h-[50vh] lg:h-screen overflow-hidden">
          <div className={`absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/chef_mexican_gastronomy_plating.png)] bg-cover bg-center transition-transform duration-[3000ms] ease-out ${isVisible ? "scale-110" : "scale-100"}`}>
            {}
            <div className="absolute inset-0 bg-gradient-to-r from-secondary-dark/60 via-transparent to-transparent lg:bg-gradient-to-b lg:from-transparent lg:via-secondary-dark/20 lg:to-secondary-dark/80" />
          </div>
          
          {}
          <div className="absolute bottom-0 right-0 w-1 h-32 bg-accent hidden lg:block" />
        </div>

        {}
        <div className="relative lg:col-span-7 flex flex-col justify-center px-6 py-16 lg:px-24 lg:py-32">
          <div className={`max-w-2xl transition-all duration-[var(--duration-slow)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            {}
            <div className="mb-12">
              <span className="text-accent font-sans font-bold tracking-[0.3em] uppercase text-sm mb-4 block">
                Nuestra Filosofía
              </span>
              <h2 className="font-display text-4xl lg:text-6xl text-white mb-8 leading-tight">
                El Arte de la <br />
                <span className="text-accent font-semibold italic">Cocina Mexicana</span>
              </h2>
              
              <div className="space-y-6 font-sans text-lg leading-relaxed text-white/80">
                <p>
                  Nuestro chef ejecutivo aporta más de dos décadas de experiencia culinaria internacional, 
                  fusionando técnicas clásicas con innovación contemporánea para crear experiencias 
                  gastronómicas que trascienden lo ordinario.
                </p>
                <p>
                  Cada creación es un tributo a la rica biodiversidad de México, donde el mezcal y el mar 
                  se encuentran para deleitar los sentidos en un entorno de lujo tropical.
                </p>
              </div>
            </div>

            {}
            <div className="mb-16 p-8 bg-white/5 border-l-2 border-accent-hover rounded-r-lg">
              <div className="font-display text-3xl text-accent font-bold italic mb-2">
                Visión de Autor
              </div>
              <p className="text-sm font-sans font-medium tracking-widest uppercase text-white/60">
                Liderazgo culinario con alma caribeña
              </p>
            </div>

            {}
            <div className="grid sm:grid-cols-2 gap-x-12 gap-y-10 mb-16">
              {values.map((value, i) => {
              const Icon = value.icon;
              return <div key={i} data-index={i} className={`flex flex-col gap-4 transition-all duration-[var(--duration-slow)] group ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`} style={{
                transitionDelay: isVisible ? `${400 + i * 100}ms` : "0ms"
              }}>
                    <div className="w-12 h-12 rounded-full bg-accent-light/40 border border-accent/40 flex items-center justify-center transition-all duration-300 group-hover:bg-accent/20 group-hover:scale-110 group-hover:shadow-soft group-hover:border-accent">
                      <Icon className="w-5 h-5 text-accent-dark" strokeWidth={2.5} />
                    </div>
                    <div>
                      <h3 className="font-display text-xl text-white mb-2">
                        {value.title}
                      </h3>
                      <p className="font-sans text-sm text-white/60 leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            {}
            <div className={`flex flex-wrap items-center gap-6 transition-all duration-[var(--duration-medium)] delay-[1000ms] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <Link to="/HomePage#reservations">
                <Button className="bg-primary hover:bg-primary-hover text-white px-10 py-7 text-base font-semibold rounded-md shadow-strong transition-all duration-300 min-w-[240px] uppercase tracking-wider">
                  Reservar Mesa
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}